<template>
  <div color="#000000">
    <!-- <v-footer  dark padless> -->
    <v-layout wrap>
      <v-flex xs12 lg12>
        <v-card flat tile color="#000000" class="white--text">
          <v-layout wrap>
            <v-flex pt-3 xs12 lg9>
              <v-card-text class="white--text pt-0">
                <v-layout wrap>
                  <v-flex xs12 lg12>
                    <span
                      style="
                        font-family: poppinsbold;
                        color: #e7ab5f;
                        font-size: 20px;
                      "
                    >
                      Contact US
                    </span>
                  </v-flex>
                </v-layout>
                <v-layout pl-3 wrap>
                  <v-flex xs12>
                    <v-layout v-if="contactUs.country" pt-3 wrap>
                      <v-flex xs12 lg12>
                        <span
                          style="font-family: poppinssemibold; font-size: 18px"
                        >
                         &nbsp; {{contactUs.country}}
                          
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout wrapn v-if="contactUs.address">
                      <v-flex xs12 lg12>
                        <span
                          style="font-family: poppinsregular; font-size: 14px"
                        >
                                                   {{contactUs.address}}

                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout v-if="contactUs.phone" wrap>
                      <v-flex xs6 lg1>
                        <span
                          style="font-family: poppinsregular; font-size: 14px"
                        >
                          Telephone :
                        </span>
                      </v-flex>
                      <v-flex xs6 lg2>
                        <span
                          style="font-family: poppinsregular; font-size: 14px"
                        >
                         &nbsp; {{contactUs.phone}}
                          
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout  v-if="contactUs.fax" wrap>
                      <v-flex xs6 lg1>
                        <span
                          style="font-family: poppinsregular; font-size: 14px"
                        >
                          Fax :
                        </span>
                      </v-flex>
                      <v-flex xs6 lg2>
                        <span
                          style="font-family: poppinsregular; font-size: 14px"
                        >
                          &nbsp;{{contactUs.fax}}
                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout  v-if="contactUs.mobile" wrap>
                      <v-flex xs6 lg1>
                        <span
                          style="font-family: poppinsregular; font-size: 14px"
                        >
                          Mobile :
                        </span>
                      </v-flex>
                      <v-flex xs6 lg2>
                        <span
                          style="font-family: poppinsregular; font-size: 14px"
                        >
                                                  &nbsp;  {{contactUs.mobile}}

                        </span>
                      </v-flex>
                    </v-layout>
                    <v-layout  v-if="contactUs.email" wrap>
                      <v-flex xs6 lg1>
                        <span
                          style="font-family: poppinsregular; font-size: 14px"
                        >
                          Email :
                        </span>
                      </v-flex>
                      <v-flex xs6 lg2>
                         <a style="text-decoration:none;color:#FFFFFF" :href="'mailto:'+contactUs.email">
                        <span
                          style="font-family: poppinsregular; font-size: 14px;"
                        >
                       
                         {{contactUs.email}}
                        </span>
                        </a>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-flex>
            <v-flex xs12 lg3>
              <v-layout wrap>
                <v-flex xs12 lg12>
                  <span
                    style="
                      font-family: poppinsbold;
                      color: #e7ab5f;
                      font-size: 20px;
                    "
                  >
                    Follow us on
                  </span>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12 lg12>
                  <!-- <v-card-text> -->
                  <v-btn
                    v-for="(item,i) in followUs"
                    :key="i"
                    class="mr-12 white--text"
                    icon
                  >
                    <!-- <v-icon size="24px">
                      {{ icon }}
                    </v-icon> -->
                   <v-img height="30px" width="30px"
                  :src="baseURL+item.icon"
                ></v-img>
                  </v-btn>
                  <!-- </v-card-text> -->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12>
        <v-card flat tile color="#000000">
          <v-layout justify-center wrap>
            <v-flex xs12 lg12 class="footer2 py-4 text-center white--text">
              <!-- <v-card> -->
              <!-- <v-card-text class="white--text"> -->
              <strong>Al Sadeel Electromechanical works L.L.C </strong> — &copy;
              {{ new Date().getFullYear() }}

              <!-- <br /> -->
           <a href="http://leopardtechlabs.com/" target="blank" style="text-decoration:none;color:white">   <strong>Powered by Leopard Tech Labs Pvt. Ltd</strong></a>
              <!-- </v-card-text> -->
              <!-- </v-card> -->
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- </v-footer> -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
    followUs:[],
    contactUs:[]
  }),
    mounted(){
    this.getFollowUs();
    this.getContactUs();
  },
  methods: {
     getFollowUs() {
      axios({
        method: "GET",
        url: "/followus/list",
      })
        .then((response) => {
          if(response.data.status)
          this.followUs = response.data.data;
        })
        .catch(() => {});
    },  
     getContactUs() {
      axios({
        method: "GET",
        url: "/contactus/view",
      })
        .then((response) => {
          if(response.data.status)
          this.contactUs = response.data.data;
        })
        .catch(() => {});
    },

  },
};
</script>
<style >
.footer2 {
  background-color: "#000000";
}
</style>